import React, { Fragment } from 'react'

import EditCompaniesModal from './EditCompaniesModal'
import NewCompanyModal from './NewCompanyModal'
import BranchModal from './BranchModal'
import AddBranchModal from './AddBranchModal'
import EditBranchModal from './EditBranchModal'
import EditNfeModal from './products/nfe/EditNfeModal'
import EditReinfModal from './products/reinf/EditReinfModal'

const ConfigCompaniesModals = props => {
  return (
    <Fragment>
      <EditCompaniesModal />
      <NewCompanyModal />
      <BranchModal />
      <AddBranchModal />
      <EditBranchModal />
      <EditReinfModal />
      <EditNfeModal />
    </Fragment>
  )
}

export default ConfigCompaniesModals



// WEBPACK FOOTER //
// ./src/components/dashboard/config/companies/ConfigCompaniesModals.js